import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
  config: {
    extensions: [reactPlugin],
    disableAjaxTracking: true,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

export const applicationInsights = ai;

export const appInsights = ai.appInsights;
